/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        $(document).ready(function($) {
          $('#slick-slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 3500,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 4000
          });

          $('.hover-trigger').on('click', function(e){
            e.preventDefault();
            var area = $(this).data('area');
            $('.cottages-container.home .info').slideUp();
            $('#'+area).slideDown();
          });


          var $container = $('#propertiescontainer_2');
          $container.isotope({
            filter: '*',
            animationOptions: {
              duration: 750,
              easing: 'linear',
              queue: false
            }
          });
          var $optionSets = $('#location');
          $optionLinks = $optionSets.find('a');
          $optionLinks.click(function(e) {
            e.preventDefault();
            var $this = $(this);
            if ( $this.hasClass('selected') ) {
              return false;
            }
            var $optionSet = $this.parents('.option-set');
            $optionSet.find('.selected').removeClass('selected');
            $this.addClass('selected');

            var filterValue = $(this).attr('data-filter');
            $container.isotope({
              filter: filterValue,
              animationOptions: {
                duration: 750,
                easing: 'linear',
                queue: false
              }
            });
            return false;
          });
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about': {
      init: function() {
        $('#slick-slider').slick({
          dots: false,
          arrows: false,
          infinite: true,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          autoplay: true,
          autoplaySpeed: 2000
        });
      }
    }
  };


  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

(function($) {
var imgTemp;

function redoImgGall() {
  $('.imgGall').click(
      function(){
        var getThisImg = $(this).attr('big');
        var altText = $(this).attr('title');
        if (altText !== undefined) {
          imgTemp = "<img src=\""+getThisImg+"\" width=\"620\" height=\"480\"><br><b>"+altText+"</b>";
        } else {
          imgTemp = "<img src=\""+getThisImg+"\" width=\"620\" height=\"480\">";
        }
        $('#disImg').html(imgTemp).hide().fadeIn('fast');
      }
  );
}

jQuery.fn.carousel = function(previous, next, options){
  var sliderList = jQuery(this).children()[0];

  if (this && sliderList) {
    var increment = $(sliderList).children().width(),
        elmnts = jQuery(sliderList).children(),
        numElmts = elmnts.length,
        sizeFirstElmnt = increment,
        shownInViewport = Math.round(jQuery(this).width() / sizeFirstElmnt),
        firstElementOnViewPort = 1,
        isAnimating = false;

    for (i = 0; i < shownInViewport; i++) {
      jQuery(sliderList).css('width',(numElmts+shownInViewport)*increment + "px");
      jQuery(sliderList).append(jQuery(elmnts[i]).clone());
      redoImgGall();
    }

    jQuery(previous).click(function(event){
      if (!isAnimating) {
        if (firstElementOnViewPort === 1) {
          jQuery(sliderList).css('left', "-" + numElmts * sizeFirstElmnt + "px");
          firstElementOnViewPort = numElmts;
        }
        else {
          firstElementOnViewPort--;
        }

        jQuery(sliderList).animate({
          left: "+=" + increment,
          y: 0,
          queue: true
        }, "swing", function(){isAnimating = false;});
        isAnimating = true;
      }

    });

    jQuery(next).click(function(event){
      if (!isAnimating) {
        if (firstElementOnViewPort > numElmts) {
          firstElementOnViewPort = 2;
          jQuery(sliderList).css('left', "0px");
        }
        else {
          firstElementOnViewPort++;
        }
        jQuery(sliderList).animate({
          left: "-=" + increment,
          y: 0,
          queue: true
        }, "swing", function(){isAnimating = false;});
        isAnimating = true;
      }
    });
  }
};


jQuery(document).ready(
    function($) {
      $('.imgGall').click(
          function(){
            var getThisImg = $(this).attr('big');
            var altText = $(this).attr('title');
            if (altText !== undefined) {
              imgTemp = "<img src=\""+getThisImg+"\" width=\"620\" height=\"480\"><br><b>"+altText+"</b>";
            } else {
              imgTemp = "<img src=\""+getThisImg+"\" width=\"620\" height=\"480\">";
            }
            $('#disImg').html(imgTemp).hide().fadeIn('fast');
          }
      );
    }
);

$(document).ready(function($) {
  $('#carousel_inner').carousel('#left_scroll', '#right_scroll');
});



// Google map
  var map_element = document.querySelector('.a-map'),
    point = window.location_list ? JSON.parse(window.location_list.points) : '';

  function initMap(map_element) {
    var map = new google.maps.Map(map_element, {
      zoom: 12,
      center: {lat: parseFloat( point[0][0] ), lng: parseFloat( point[0][1] )}
    });

    var markers = [];

    point.forEach(function (el) {
      var iconNew = {
        url: location_list.siteurl + '/assets/images/paw-icon.svg',
        scaledSize: new google.maps.Size(40, 40),
      };

      var location = new google.maps.LatLng(el[0], el[1]);

      var marker = new google.maps.Marker({
        map: map,
        position: location,
        icon: iconNew
      });

      var content_window = '<div class="a-info-window">' +
        '<div class="a-info-window__img" style="background-image: url(' + el[2] + ');"></div>' +
        '<div class="a-info-window__text">' + el[3] + '</div>' +
        '</div>';

      // create info window
      var info_window = new google.maps.InfoWindow();
      info_window.setContent(content_window);

      marker.addListener('click', function() {
        info_window.open(map, marker);
      });

      markers.push(marker);
    });
  }

  if ( map_element ) {
    initMap(map_element);
  }

})(jQuery); // Fully reference jQuery after this point.

(function($) {
  $('#header_detail_close').click(function() {
    $('.header_detail_container').css('display', 'none');
    localStorage.setItem('header_detail_stause', 'hide');
  });
})(jQuery);
